const sanityConfig = {
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID!,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET!,
  apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION!,
};

interface ImageLoaderProps {
  src: string;
  width?: number;
  quality?: number;
}

export default function imageLoader({ src, width = 48, quality = 75 }: ImageLoaderProps) {
  if (!src) return '';

  if (src.startsWith('./') || src.startsWith('/')) return src;

  if (src.includes('https')) return `${src}?w=${width}&q=${quality}&fit=crop&auto=format`;

  const ref = src?.split('-');
  const ext = ref.pop();
  ref.shift();
  const refStr = ref.join('-');

  return `https://cdn.sanity.io/images/${sanityConfig.projectId}/${sanityConfig.dataset}/${refStr}.${ext}?w=${width}&q=${quality}&fit=crop&auto=format`;
}
